import APIClient from '@/shared/http/clients/apiupload.js'
const resourceName = '/arquivos/compartilhados'
const APICore = process.env.APIBaseURLCore

const GetDownloadUrl = (uuid, data = {}, config = {}) =>
  APIClient.get(`${APICore}${resourceName}/${uuid}/download`, data, config)

const Download = {
  GetDownloadUrl
}

export default Download



// WEBPACK FOOTER //
// ./src/shared/http/repositories/download/download.js